
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("\n")
    ; for(var i=0;i<items.length;i++){
    ; __append("\n\n<div class=\"mod-box\">\n    \n    ")
    ; if (items[i].dateStr){
    ; __append("\n    <div class=\"mod-lineTitle clearfix\">\n        <div class=\"left-line fl\"></div>\n    </div>\n    ")
    ; }
    ; __append("\n    <div class=\"mod-news-block\">\n        ")
    ; (function(){
    ; __append("\n\n<div class=\"mod-news-content\">\n    <div class=\"news-con\">\n        ")
    ;  if (items[i].title){
    ; __append("\n        <h3 class=\"news-title\">\n            ")
    ;  if (items[i].title_link){
    ; __append("\n            <a href=\"")
    ; __append(escape(items[i].title_link))
    ; __append("\" target=\"_blank\">")
    ; __append(escape(items[i].title))
    ; __append("</a>\n            ")
    ; }else{
    ; __append("\n            <span>")
    ; __append(escape(items[i].title))
    ; __append("</span>\n            ")
    ; }
    ; __append("\n        </h3>\n        ")
    ; }
    ; __append("\n\n        ")
    ;  if (items[i].abstract1){
    ; __append("\n        <div class=\"info\">\n            ")
    ;  if (items[i].hasContent){
    ; __append("\n            ")
    ; __append(escape(items[i].abstract1))
    ; __append("\n            ")
    ;  if (items[i].abstract_link){
    ; __append("<a href=\"")
    ; __append(escape(items[i].abstract_link))
    ; __append("\" target=\"_blank\">【详细】</a>")
    ; }
    ; __append("\n            ")
    ; }
    ; __append("\n        </div>\n        ")
    ; }
    ; __append("\n\n    </div>\n</div>")
    ; }).call(this)
    ; __append("\n        <div class=\"mod-news-time  clearfix\">\n            <span class=\"time fl\">")
    ; __append(escape(items[i].covertime))
    ; __append("</span>\n           \n        </div>\n        \n    </div>\n</div>\n")
    ; }
    ; __append("\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.pagelist.pc/app/modules/view/topItem.ejs
// module id = 441
// module chunks = 0